import { Mail } from "lucide-react";
import React from "react";

const NoEmployeeTicketSelected = (): JSX.Element => (
  <div className="flex-1">
    <div className="flex flex-col items-center justify-center h-full border border-dashed rounded border-jem-primary-20t">
      <Mail className="w-[40px] h-[40px] text-[#829099]" />
      <p className="mt-3 font-bold text-jem-primary-base">No item selected</p>
    </div>
  </div>
);

export default NoEmployeeTicketSelected;
